import * as React from "react"
import {useEffect} from "react"
import {object, string} from "yup";
import {TextFieldSeeker} from "@ui-seeker/core";
import {useValidatorSeeker} from "@ui-seeker/app";

import {useMatchersSkusForm} from "../../@hooks";
import {matcherSKUDrawerError} from "../../@signals";


export default function MatchersSKUsDrawerSkuName() {
	const { localValue, handleChange } = useMatchersSkusForm('productTitle')
	const { errors } = useValidatorSeeker({
		productTitle: localValue
	}, object({
		productTitle: string().required('SKU Name is mandatory')
	}))

	useEffect(() => {
		matcherSKUDrawerError.value = {
			...matcherSKUDrawerError.value,
			productTitle: errors?.productTitle
		}
	}, [errors?.productTitle]);

    return <TextFieldSeeker
		fullWidth
		label="SKU Name"
		placeholder="Please enter the SKU name"
		value={localValue || ''}
		onChange={e => handleChange(e.target.value)}
		error={errors?.productTitle}
	/>
}
